import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioTooltipDirective } from '@immomio/ui/tooltip';
import { ImageComponent } from '../../../atoms/image/image.component';
import { CardComponent } from '../../../atoms/card/card.component';
import { isValueNotNullAndUndefined } from '../../../../utils/coercion';

@Component({
  selector: 'app-property-group-card',
  templateUrl: './property-group-card.component.html',
  styleUrls: ['./property-group-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CardComponent,
    ImageComponent,
    ImmomioTooltipDirective,
    TranslatePipe
  ]
})
export class PropertyGroupCardComponent {
  readonly imageUrl = input('');
  readonly title = input('');
  readonly subTitle = input('');
  readonly propertiesCount = input(0);
  readonly propertiesCountTotal = input(0);
  readonly propertiesCountAdded = input(0);
  readonly propertiesCountTooltipText = input<string | null>(null);

  public baseClass = 'property-group-card';

  get imageUrlWithFallback(): string {
    return this.imageUrlHasBeenSet()
      ? this.imageUrl()
      : '/assets/images/object-image-placeholder.svg';
  }

  public imageUrlHasBeenSet(): boolean {
    const imageUrl = this.imageUrl();
    return imageUrl !== '' && isValueNotNullAndUndefined(imageUrl);
  }
}
